/* eslint-disable import/no-anonymous-default-export */
import axiosInstance from "../../../helpers/axiosInstance";
import { CONNECTION_ERROR } from "../../../constants/apiConstants";
import {
  APLICATIONS_LOADING,
  APLICATIONS_LOAD_SUCCESS,
  APLICATIONS_LOAD_ERROR,
} from "../../../constants/actionTypes";

export default () => (dispatch) => {
  dispatch({
    type: APLICATIONS_LOADING,
  });
  axiosInstance
    .get("backoffice/Aplicacion/GetList")
    .then((res) => {
      if (res.data.status !== "Error") {
        dispatch({
          type: APLICATIONS_LOAD_SUCCESS,
          payload: res.data.results,
        });
      } else {
        dispatch({
          type: APLICATIONS_LOAD_ERROR,
          payload: res.data.errors[0],
        });
      }
    })
    .catch((err) => {
      dispatch({
        type: APLICATIONS_LOAD_ERROR,
        payload: err.response ? err.response.data : CONNECTION_ERROR,
      });
    });
};
